import Styles from './ChatInput.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { Sliders } from 'blaze-ui/icons/16'
import { Image03 } from 'blaze-ui/icons/24'
import { Caption, ColorSwatch2, Menu2 } from 'blaze-ui/icons'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { PROMPT_SUGGESTIONS } from '../Messages/Suggestions'
import { ToolsMenuProps } from './Types'

export const ToolsMenu = ({ onChange }: ToolsMenuProps) => {
  const handleAction = (key: React.Key) => {
    switch (key) {
      case 'image':
        onChange(PROMPT_SUGGESTIONS.image)
        break
      case 'colors':
        onChange(PROMPT_SUGGESTIONS.colors)
        break
      case 'text':
        onChange(PROMPT_SUGGESTIONS.text)
        break
      case 'caption':
        onChange(PROMPT_SUGGESTIONS.caption)
        break
      default:
        break
    }
  }

  return (
    <MenuTrigger>
      <Button frontIcon={Sliders} onPress={() => {}} size="sm" variant="ghost-tertiary" rounded>
        <Text variant="secondary" color="var(--selected-fill)">
          Tools
        </Text>
      </Button>
      <Menu aria-label="Menu" onAction={handleAction} className={Styles.menu}>
        <Item key="image" textValue="Change Image">
          <Image03 size={16} color="var(--dark-80)" />
          <Text variant="secondary" color="var(--dark-80)">
            Change Image
          </Text>
        </Item>
        <Item key="colors" textValue="Change Colors">
          <ColorSwatch2 size={16} color="var(--dark-80)" />
          <Text variant="secondary" color="var(--dark-80)">
            Change Colors
          </Text>
        </Item>
        <Item key="text" textValue="Change Text">
          <Menu2 size={16} color="var(--dark-80)" />
          <Text variant="secondary" color="var(--dark-80)">
            Change Text
          </Text>
        </Item>
        <Item key="caption" textValue="Change Caption">
          <Caption size={16} color="var(--dark-80)" />
          <Text variant="secondary" color="var(--dark-80)">
            Change Caption
          </Text>
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
